<template>
<div>
<div class="basic-margin cd-title-label"><b>数据明细</b>
  <el-col style="cursor:pointer;padding-left:77px;margin-top:-22px;">
    <el-tooltip placement="top" >
    <div slot="content">
        展示了每日各项数据明细。（均为截止昨日数据，每晚0点更新）
      </div>
      <span class="el-icon-information" ></span>
    </el-tooltip>
  </el-col>

</div>

  <el-table
    :data="datas"
    style="width: 100%">
    <el-table-column
      prop="date"
      label="日期">
      <template scope="scope">
        <el-icon name="time"></el-icon>
        <span style="margin-left: 10px">{{ scope.row.date }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="uvCount"
      label="浏览量uv">
    </el-table-column>
    <el-table-column
      prop="pvCount"
      label="页面pv">
    </el-table-column>
    <el-table-column
      prop="clueCount"
      label="线索量">
    </el-table-column>
    <el-table-column
      prop="clueIncome"
      label="线索收入">
    </el-table-column>
  </el-table>

    <el-pagination
    class="row basic-margin"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>

</div>
</template>
<style media="screen" >
.cd-title-label{
  margin-top: 25px;
  color: rgb(32, 160, 255);
  font-size: 17px;
  margin-bottom: 10px;
}
</style>
<script>
import DataMonitorModel from '../../../framework/models/dataMonitorModel'
import BasicPager from '../../../mixins/BasicPager'
export default {
  name: 'clue-data-detail',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0// 总条数
    }
  },
  created: function () {
    if (localStorage.userInfo) { this.loadList() }
  },
  props: {
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        currentPage: _this.currentPage,
        pageSize: _this.pageSize
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
        }
      }
      DataMonitorModel.findDataDetail(_this, params, listener)
    }
  }
}
</script>
